<template>
  <div id="WeightDetail" style="width: 100%; margin: 20px auto;    background: white;">
    <div>
      <div ref="chartBox" class="chart-box"></div>
    </div>
    <div class="date-box">
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="date-weight" v-for="(item,index) in dates" :key="'a'+index">{{ item }}</span>
    </div>
    <WeightRow :leftPlaceHoderCount="0" :rightPlaceHoderCount="4" :weightData="weightData">
      <template #detail0>
        <WeightRow :leftPlaceHoderCount="1" :rightPlaceHoderCount="3" :weightData="natureWeightData">
          <template #detail0>
            <WeightRow :leftPlaceHoderCount="2" :rightPlaceHoderCount="2" :weightData="natureClickWeightData"></WeightRow>
          </template>
          <template #detail1>
            <WeightRow :leftPlaceHoderCount="2" :rightPlaceHoderCount="2" :weightData="natureOrderWeightData"></WeightRow>
          </template>
          <!-- <template #detail2>
            <WeightRow :leftPlaceHoderCount="2" :rightPlaceHoderCount="1" :weightData="weightData.detailList[0].detailList[2]"></WeightRow>
          </template> -->
        </WeightRow>
      </template>
      <template #detail1>
        <WeightRow :leftPlaceHoderCount="1" :rightPlaceHoderCount="3" :weightData="adWeightData">
          <template #detail0>
            <WeightRow :leftPlaceHoderCount="2" :rightPlaceHoderCount="2" :weightData="adMKWeightData">
              <template #detail0>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adMKImpressionWeightData"></WeightRow>
              </template>
              <template #detail1>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adMKClickWeightData"></WeightRow>
              </template>
              <template #detail2>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adMKOrderWeightData">
                  <template #detail0>
                    <WeightRow :leftPlaceHoderCount="4" :rightPlaceHoderCount="0" :weightData="adMKAdSkuOrderWeightData"></WeightRow>
                  </template>
                  <template #detail1>
                    <WeightRow :leftPlaceHoderCount="4" :rightPlaceHoderCount="0" :weightData="adMKOtherSkuOrderWeightData"></WeightRow>
                  </template>
                </WeightRow>
              </template>
            </WeightRow>
          </template>
          <template #detail1>
            <WeightRow :leftPlaceHoderCount="2" :rightPlaceHoderCount="2" :weightData="adACWeightData">
              <template #detail0>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adACImpressionWeightData"></WeightRow>
              </template>
              <template #detail1>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adACClickWeightData"></WeightRow>
              </template>
              <template #detail2>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adACOrderWeightData">
                  <template #detail0>
                    <WeightRow :leftPlaceHoderCount="4" :rightPlaceHoderCount="0" :weightData="adACAdSkuOrderWeightData"></WeightRow>
                  </template>
                  <template #detail1>
                    <WeightRow :leftPlaceHoderCount="4" :rightPlaceHoderCount="0" :weightData="adACOtherSkuOrderWeightData"></WeightRow>
                  </template>
                </WeightRow>
              </template>
            </WeightRow>
          </template>
          <template #detail2>
            <WeightRow :leftPlaceHoderCount="2" :rightPlaceHoderCount="2" :weightData="adALWeightData">
              <template #detail0>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adALImpressionWeightData"></WeightRow>
              </template>
              <template #detail1>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adALClickWeightData"></WeightRow>
              </template>
              <template #detail2>
                <WeightRow :leftPlaceHoderCount="3" :rightPlaceHoderCount="1" :weightData="adALOrderWeightData">
                  <template #detail0>
                    <WeightRow :leftPlaceHoderCount="4" :rightPlaceHoderCount="0" :weightData="adALAdSkuOrderWeightData"></WeightRow>
                  </template>
                  <template #detail1>
                    <WeightRow :leftPlaceHoderCount="4" :rightPlaceHoderCount="0" :weightData="adALOtherSkuOrderWeightData"></WeightRow>
                  </template>
                </WeightRow>
              </template>
            </WeightRow>
          </template>
        </WeightRow>
      </template>
    </WeightRow>
  </div>
</template>
  
<script>
import {
  requestModules
} from '@r'
import WeightRow from './WeightRow.vue';
import * as echarts from 'echarts';
export default {
  components: { WeightRow },
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 68,
      keyword: this.$route.query.keyword,
      asin: this.$route.query.asin,
      dataList: [],
      totalWeight: 0,
      weightData: { detailList: [] },
      params: { asin: this.$route.query.asin },
      dates: [],

      adWeightData: { detailList: [] },
      natureWeightData: { detailList: [] },
      adMKWeightData: { detailList: [] },
      adMKImpressionWeightData: { detailList: [] },
      adMKClickWeightData: { detailList: [] },
      adMKOrderWeightData: { detailList: [] },
      adMKAdSkuOrderWeightData: { detailList: [] },
      adMKOtherSkuOrderWeightData: { detailList: [] },
      adACWeightData: { detailList: [] },
      adACImpressionWeightData: { detailList: [] },
      adACClickWeightData: { detailList: [] },
      adACOrderWeightData: { detailList: [] },
      adACAdSkuOrderWeightData: { detailList: [] },
      adACOtherSkuOrderWeightData: { detailList: [] },
      adALWeightData: { detailList: [] },
      adALImpressionWeightData: { detailList: [] },
      adALClickWeightData: { detailList: [] },
      adALOrderWeightData: { detailList: [] },
      adALAdSkuOrderWeightData: { detailList: [] },
      adALOtherSkuOrderWeightData: { detailList: [] },
      natureWeightData: { detailList: [] },
      natureClickWeightData: { detailList: [] },
      natureOrderWeightData: { detailList: [] },

      chartOptions: {
        legend: {
          top: 10,
          left: 'center'
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [

        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          position: function (pos, params, el, elRect, size) {
            var obj = { top: 10 };
            obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          extraCssText: 'width: 170px'
        },
        axisPointer: {
          link: { xAxisIndex: 'all' },
          label: {
            backgroundColor: '#777'
          }
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false
            },
            brush: {
              type: ['lineX', 'clear']
            }
          }
        },
        brush: {
          xAxisIndex: 'all',
          brushLink: 'all',
          outOfBrush: {
            colorAlpha: 0.1
          }
        },
      }
    };
  },
  mounted() {
    this.getAdvertData()
  },
  methods: {
    getAdvertData() {
      requestModules.fetchProductWeight(this.params).then(res => {
        // this.dataList = res.ldata;
        this.weightData = res.mdata;

        this.natureWeightData = this.weightData.detailList[0];
        this.natureClickWeightData = this.weightData.detailList[0].detailList[0];
        this.natureOrderWeightData = this.weightData.detailList[0].detailList[1];

        this.adWeightData = this.weightData.detailList[1];
        this.adMKWeightData = this.weightData.detailList[1].detailList[0];
        this.adMKImpressionWeightData = this.weightData.detailList[1].detailList[0].detailList[0];
        this.adMKClickWeightData = this.weightData.detailList[1].detailList[0].detailList[1];
        this.adMKOrderWeightData = this.weightData.detailList[1].detailList[0].detailList[2];
        this.adMKAdSkuOrderWeightData = this.weightData.detailList[1].detailList[0].detailList[2].detailList[0];
        this.adMKOtherSkuOrderWeightData = this.weightData.detailList[1].detailList[0].detailList[2].detailList[1];
        this.adACWeightData = this.weightData.detailList[1].detailList[1];
        this.adACImpressionWeightData = this.weightData.detailList[1].detailList[1].detailList[0];
        this.adACClickWeightData = this.weightData.detailList[1].detailList[1].detailList[1];
        this.adACOrderWeightData = this.weightData.detailList[1].detailList[1].detailList[2];
        this.adACAdSkuOrderWeightData = this.weightData.detailList[1].detailList[1].detailList[2].detailList[0];
        this.adACOtherSkuOrderWeightData = this.weightData.detailList[1].detailList[1].detailList[2].detailList[1];
        this.adALWeightData = this.weightData.detailList[1].detailList[2];
        this.adALImpressionWeightData = this.weightData.detailList[1].detailList[2].detailList[0];
        this.adALClickWeightData = this.weightData.detailList[1].detailList[2].detailList[1];
        this.adALOrderWeightData = this.weightData.detailList[1].detailList[2].detailList[2];
        this.adALAdSkuOrderWeightData = this.weightData.detailList[1].detailList[2].detailList[2].detailList[0];
        this.adALOtherSkuOrderWeightData = this.weightData.detailList[1].detailList[2].detailList[2].detailList[1];

        this.dates = [];
        for (let i = 0; i < 30; i++) {
          let date = new Date(new Date(this.weightData.date).getTime() - i * 24 * 60 * 60 * 1000).format("MM-dd")
          this.dates.push(date);
        }

        this.chartOptions.xAxis.data = this.dates;
        let natureWeightList = []
        let natureClickWeightList = []
        let natureOrderWeightList = []
        let adWeightList = []
        let adMKWeightList = []
        let adACWeightList = []
        let adALWeightList = []
        this.dates.forEach((date, index) => {
          natureWeightList.push(this.natureWeightData.dateList[index].weight * this.weightData.baseNatureWeight)
          natureClickWeightList.push(this.natureClickWeightData.dateList[index].weight * this.weightData.baseNatureWeight * this.natureWeightData.baseClickWeight)
          natureOrderWeightList.push(this.natureOrderWeightData.dateList[index].weight * this.weightData.baseNatureWeight * this.natureWeightData.baseOrderWeight)
          adWeightList.push(this.adWeightData.dateList[index].weight * this.weightData.baseAdWeight)
          adMKWeightList.push(this.adMKWeightData.dateList[index].weight * this.weightData.baseAdWeight * this.adWeightData.baseManualKeywordWeight)
          adACWeightList.push(this.adACWeightData.dateList[index].weight * this.weightData.baseAdWeight * this.adWeightData.baseAutoCloseWeight)
          adALWeightList.push(this.adALWeightData.dateList[index].weight * this.weightData.baseAdWeight * this.adWeightData.baseAutoLooseWeight)
        });
        this.chartOptions.series = [
          {
            data: natureWeightList,
            type: 'line',
            smooth: true,
            name: "自然权重"
          },
          {
            data: natureClickWeightList,
            type: 'line',
            smooth: true,
            name: "自然点击权重"
          },
          {
            data: natureOrderWeightList,
            type: 'line',
            smooth: true,
            name: "自然成交权重"
          },
          {
            data: adWeightList,
            type: 'line',
            smooth: true,
            name: "广告权重"
          },
          {
            data: adMKWeightList,
            type: 'line',
            smooth: true,
            name: "手动关键词广告权重"
          },
          {
            data: adACWeightList,
            type: 'line',
            smooth: true,
            name: "紧密匹配广告权重"
          },
          {
            data: adALWeightList,
            type: 'line',
            smooth: true,
            name: "广泛匹配广告权重"
          }
        ]

        this.initChart();
      });
    },
    initChart() {
      var myChart = echarts.init(this.$refs.chartBox);
      myChart.setOption(this.chartOptions);
    }
  },
  computed: {
    tableData() {
      let list = [...this.advertData];

      return list
    }
  },
};
  </script>
  
<style lang="scss">
#WeightDetail {
  .date-box {
    span {
      display: inline-block;
      font-size: 12px;
      width: 43px;
      text-align: right;
    }
    .type-label,
    .weight {
      width: 60px;
    }
    .placeholder {
      width: 60px;
    }
  }
  .chart-box {
    width: 100%;
    height: 400px;
  }
}
</style>
  